export default "__VITE_ASSET__DTcgDoD5__"